import { useState, useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link, useLocation } from "react-router-dom";
// import { Notification, Setting, Account, getIcons } from '../../styles/icons/svg';
// import { Notification, Setting } from '../../styles/icons/svg';
import { getIcons } from '../../styles/icons/svg';
import { selectChildMenu, selectMenu, resetMenuState  } from '../../redux/features/menuSlice';
import { getMenusAction } from '../../services/actions/menuActions';
import { userLogout } from "../../services/apis/userApi";
import { hasAccess } from "../../components/generics/helper";
import LoaderScreen from "../../components/generics/Loader";
// import { ChildMenu } from './ChildMenu.component';
import ConfirmationDialogRaw from "../../components/generics/ConfirmationDialogRaw";
import '../../styles/header/header.scss';
import HamburgerMenu from "./HamburgerMenu";
import { useSnackbar } from "notistack"
import MenuIcon from '@mui/icons-material/Menu';
import { Collapse, Drawer, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAnglesRight, faXmark } from "@fortawesome/free-solid-svg-icons";

export const Header = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const { isMenuLoaded, menuData, selectedMenu, selectedChildMenu } = useSelector((state) => state.menus);
  const { selectedRolesRights = [], adminType = 0 } = useSelector((state) => state.login?.userData);
  const { userData} = useSelector((state) => state.login);
  const [showLogoutConfirm, setShowLogoutConfirm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [open, setOpen] = useState(false)
  const { enqueueSnackbar } = useSnackbar();
  useEffect(() => {
    const selectDefaultMenu = async () => {
      let selectedMenu = menuData.modules.find((menu) => location.pathname.indexOf(menu.path) >= 0);
      let selectedSubMenu = selectedMenu?.childrens?.find(c =>
        location?.pathname.startsWith(c?.path)
      );
      if (selectedMenu) {
        dispatch(selectMenu(selectedMenu.name));
      }
      if (selectedSubMenu) {
        dispatch(selectChildMenu(selectedSubMenu?.name));
      }
    }

    const getMenuData = async (userToken) => {
      const response = await dispatch(getMenusAction(userToken));
      if (response.status === 'Ok') {
        if (isMenuLoaded)
          selectDefaultMenu();
      }
    }
    if (!isMenuLoaded) {
      getMenuData(localStorage.getItem('userToken'));
    } else {
      if (!selectedMenu)
        selectDefaultMenu();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMenuLoaded])

useEffect(() => {
  const menu = menuData?.modules?.find(m =>
    location?.pathname?.startsWith(m?.path)
  );
  if (menu) dispatch(selectMenu(menu?.name));

  const child = menu?.childrens?.find(c =>
    location?.pathname.startsWith(c?.path)
  );
  if (child) dispatch(selectChildMenu(child?.name));
    // eslint-disable-next-line react-hooks/exhaustive-deps
}, [location.pathname]);

  // const handleMenuSelection = async (menuName) => {
  //   dispatch(selectMenu(menuName));
  // }

  const logout = () => {
    setShowLogoutConfirm(true);
  }

  const logoutConfirmation = async (confirmation) => {
    setShowLogoutConfirm(false);
    setIsLoading(true);
    if (confirmation) {
      // Process Logout
      const logoutResponse = await userLogout(localStorage.getItem('userToken'));
      if (logoutResponse.status === 'Ok' && logoutResponse.data.responseStatus === 'Ok') {
        setIsLoading(false);
        dispatch(resetMenuState());
        localStorage.removeItem('userToken');
        navigate('/login', { replace: true });
      } else {
        setIsLoading(false);
        enqueueSnackbar(logoutResponse.errorMessage || "Logout Failed", { variant: 'error' });
      }

    } else {
      setIsLoading(false);
    }
  }

  // const renderTab = () => {
  //   return menuData && menuData.modules.map((el, i) => {
  //     return hasAccess(selectedRolesRights, el.pCode, adminType) &&
  //       <div key={'Menu-' + el.code}>
  //         <Link key={'Link-' + el.name + '-' + i} to={el.path} style={{ textDecoration: 'none' }}>
  //           <div key={el.name + '_' + i} className={`head--tab${el.name === selectedMenu?.name ? ' active' : ''}`} onClick={() => handleMenuSelection(el.name)}>
  //             <div key={'MenuIcon-' + el.code}>{getIcons(el.name)}</div>
  //             <div key={'MenuName-' + el.code}>{el.displayName}</div>
  //           </div>
  //         </Link>
  //       </div>
  //   });
  // }
    const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };
  const [expandedMenu, setExpandedMenu] = useState(null);

 const handleExpand = (menu, hasChildren) => {
  if (hasChildren) {
    setExpandedMenu(prev =>
      prev === menu.code ? null : menu.code
    );
  }
};

const handleSubMenuClick = () => {
  setOpen(false)
}
  const RenderDrawer = () => {
    return (
      <Drawer open={open} onClose={toggleDrawer(false)}
       transitionDuration={800}
        anchor={'left'}
        PaperProps={{
          sx: {
            width: {
              xs: '75vw',
              sm: '55vw',
              md: '40vw',
              lg: '26vw',
              xl: '22vw',
            },
            maxWidth: '300px',
          },
          className: "jc--scroll drawer--paper",
        }}
      >
       <List className="drawer-menu-list">
          <div className="drawer--header">
            <FontAwesomeIcon icon={faXmark} color={"#FFF"} fontSize={'30px'} style={{ cursor: "pointer" }}
              onClick={() => setOpen(false)} />
            <span className="drawer--header--title">MENU</span>
          </div>
          {menuData &&
            menuData.modules.map((el) => {
              if (!hasAccess(selectedRolesRights, el.pCode, adminType)) return null;

              const hasChildren = el?.childrens?.length > 0;
              const isOpen = expandedMenu === el?.code;

              return (
                <div key={el.code}>

                  {/* Main Menu */}
                  <ListItem
                    button
                    onClick={() => handleExpand(el, hasChildren)}
                    component={!hasChildren ? Link : "div"}
                    to={!hasChildren ? el.path : undefined}
                    className={`main-menu-item ${expandedMenu === el.code ? "main-menu-active" : ""
                      }`}
                  >
                    <ListItemIcon className='main-menu-icon'
                      sx={{
                        "& svg": {
                          color: selectedMenu?.code === el?.code ? "#fff" : "#000",
                        },
                      }}>{getIcons(el?.name)}</ListItemIcon>

                    <ListItemText className='main-menu-text' primary={el?.displayName}
                      sx={{
                        '& .MuiTypography-root': {
                          fontWeight: expandedMenu === el?.code ? 600 : 500,
                        },
                      }}
                    />
                  </ListItem>

                  {/* Sub Menu */}
                  {hasChildren && (
                    <Collapse
                      in={isOpen}
                      timeout={{ enter: 1100, exit: 900 }}
                      easing={{
                        enter: 'ease-out',
                        exit: 'ease-in',
                      }}
                      unmountOnExit
                    >
                      <div className="submenu-collapse-wrapper" style={{ background: '#eaf0ff' }}>
                        <List className="child-menu-list">
                          {el.childrens.map((child) => {
                            if (!hasAccess(selectedRolesRights, child.pCode, adminType)) return null;
                            return (

                              <ListItem
                                key={child.code}
                                button
                                component={Link}
                                to={child.path}
                                onClick={() => handleSubMenuClick()}
                                className={`submenu-item ${selectedChildMenu?.name === child?.name ? "submenu-active" : ""
                                  }`}
                              >
                                <ListItemText
                                  className="submenu-text"
                                  primary={child?.displayName}
                                />
                              </ListItem>
                            );
                          })}
                        </List>
                      </div>
                    </Collapse>
                  )}
                </div>
              );
            })}
        </List>
      </Drawer>
    );
  };
const currentMenu = menuData?.modules?.find(m => m?.name === selectedMenu?.name);
const currentChildMenu = currentMenu?.childrens?.find(c => c?.name === selectedChildMenu?.name);
return (
    <div>
      <div className='header--wrapper'>
        <div className='menu--wrapper' key='header-menu-icon' onClick={()=>{setOpen(!open)}}> {!open?<MenuIcon style={{color:'#FFF', fontSize: '30px'}} />: <FontAwesomeIcon icon={faXmark} color={"#FFF"} fontSize={'30px'}  />}</div>
        <div className='header--items' key='header-items'>
        <div className='logo--wrapper' key='header-logo'><img key='company-logo' src="/images/maventech-logo.png" style={{ width: '40px' }} alt="logo" />
        </div>
        <div style={{display:'flex', color:'#fff', fontSize:'15px', fontWeight:'700', gap:'8px'}}>
          <span>{'VMS'}</span>
          {currentMenu?.displayName ? <span style={{ marginTop: '1px' }}>
            <FontAwesomeIcon icon={faAnglesRight} />
          </span> : ''}
          <span>{currentMenu?.displayName || ''}</span>
          {currentChildMenu?.displayName ? <span style={{ marginTop: '1px' }}>
            <FontAwesomeIcon icon={faAnglesRight} />
          </span> : ''}
            <span>{currentChildMenu?.displayName || ''}</span>
          </div>
          <RenderDrawer />
        </div>
        <div style={{color:'#fff',fontSize:'15px', width:'300px', padding:'8px',  display: 'flex', justifyContent:'flex-end',alignItems:'center'}}>{userData?.userName}{` (${userData?.branchCode})`}</div>
        <div className='header--user--profile' key='header-profile'>
          {/* <div key='prof-noti'><Notification /></div>
          <div key='prof-setting'><Setting /></div> */}
          {/* <div key='prof-acc'><Account /></div> */}
          <div key='prof-signOut' style={{ color: "#fff", fontSize: "18px", cursor: "pointer" }}><HamburgerMenu logout={logout} /></div>
          {/* <div key='prof-signOut' style={{ color: "#fff", fontSize: "18px", cursor: "pointer" }} onClick={() => logout()}><FontAwesomeIcon icon={faSignOut} /></div> */}
        </div>
        <ConfirmationDialogRaw
          id="logout--confirmation"
          keepMounted
          open={showLogoutConfirm}
          onClose={logoutConfirmation}
          dialogConfirmationTitle="Logout Confirmation"
          dialogConfirmationMessage={"Are you sure you want to logout ? "}
        />
        {isLoading && <LoaderScreen message="Logging out..." />}
      </div>
      {/* {selectedMenu?.childrens?.length > 0 && <ChildMenu />} */}
    </div>
  );
};